import { render, staticRenderFns } from "./CreateQuesModal.vue?vue&type=template&id=603943cb&scoped=true&"
import script from "./CreateQuesModal.vue?vue&type=script&lang=js&"
export * from "./CreateQuesModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateQuesModal.vue?vue&type=style&index=0&id=603943cb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "603943cb",
  null
  
)

export default component.exports